import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

export interface CourseCreateResult {
  course_name: string;
  description: string;
}

@Component({
  selector: 'app-course-create-dialog',
  templateUrl: './course-create-dialog.component.html',
  styleUrl: './course-create-dialog.component.scss',
})
export class CourseCreateDialogComponent {
  courseName = '';
  description = '';
  submitted = false;
  saving = false;
  onConfirm: (result: CourseCreateResult) => void = () => {};

  constructor(protected dialogRef: NbDialogRef<CourseCreateDialogComponent>) {}

  submit() {
    this.submitted = true;
    if (!this.courseName.trim()) return;
    this.saving = true;
    this.onConfirm({
      course_name: this.courseName.trim(),
      description: this.description.trim(),
    });
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
